import { DocumentSortBy, DocumentType } from "@digits-graphql/frontend/graphql-bearer"
import {
  VaultFilterCategory,
  VaultFilterType,
} from "src/frontend/components/OS/Applications/Vault/VaultBrowser/useVaultFilters"

export const VAULT_LABELS = {
  [VaultFilterType.pdf]: "PDF",
  [VaultFilterType.docs]: "Documents",
  [VaultFilterType.sheets]: "Spreadsheets",
  [VaultFilterType.imgs]: "Images",
  [VaultFilterType.creator]: "Uploaded by",
  [VaultFilterType.documentType]: "File Category",
  [VaultFilterCategory.fileType]: "File Type",
} as const satisfies Record<VaultFilterType | VaultFilterCategory, string>

export const DOCUMENT_TYPE_LABELS = {
  [DocumentType.Bill]: "Bill",
  [DocumentType.Compliance]: "Compliance",
  [DocumentType.Contract]: "Contract",
  [DocumentType.Equity]: "Equity",
  [DocumentType.Form1099]: "1099",
  [DocumentType.FormW9]: "W9",
  [DocumentType.Invoice]: "Invoice",
  [DocumentType.K1]: "K1",
  [DocumentType.LoanAgreement]: "Loan Agreement",
  [DocumentType.Payroll]: "Payroll",
  [DocumentType.Receipt]: "Receipt",
  [DocumentType.Schedule]: "Schedule",
  [DocumentType.Statement]: "Statement",
  [DocumentType.TaxID]: "Tax ID",
  [DocumentType.TaxReturn]: "Tax Return",
  [DocumentType.UnknownType]: "Other",
  [DocumentType.Valuation]: "Valuation",
} as const satisfies Record<(typeof FILTERABLE_DOCUMENT_TYPES)[number], string>

export const DOCUMENT_SORT_LABELS = {
  [DocumentSortBy.Title]: "Document Name",
  [DocumentSortBy.CreatedAt]: "Uploaded On",
  [DocumentSortBy.DocumentType]: "Document Type",
  [DocumentSortBy.FileSize]: "File Size",
  [DocumentSortBy.FileName]: "File Name",
} as const satisfies Record<DocumentSortBy, string>

export const FILTERABLE_FILE_TYPES = [
  VaultFilterType.pdf,
  VaultFilterType.sheets,
  VaultFilterType.docs,
  VaultFilterType.imgs,
] as const

export const FILTERABLE_DOCUMENT_TYPES = [
  DocumentType.Bill,
  DocumentType.Compliance,
  DocumentType.Contract,
  DocumentType.Equity,
  DocumentType.Form1099,
  DocumentType.FormW9,
  DocumentType.Invoice,
  DocumentType.K1,
  DocumentType.LoanAgreement,
  DocumentType.Payroll,
  DocumentType.Receipt,
  DocumentType.Schedule,
  DocumentType.Statement,
  DocumentType.TaxID,
  DocumentType.TaxReturn,
  DocumentType.Valuation,
  DocumentType.UnknownType, // intentionally placing Unknown last as it will be our "other" category
] as const satisfies DocumentType[]
